(ns ui.wallet.i18n.nl
  "Dutch dictionary of the wallet page (see `ui.wallet.i18n`).")

(def dictionary
  {:page/loading "laden..."
   :page/command-failed "Er ging iets mis. Probeer het opnieuw of stuur ons een bericht via de chat als het blijft gebeuren."

   :balance/total-available "Beschikbaar saldo"
   :balance/pay-as-you-go "Pay-as-you-go-saldo"
   :balance/used-up "Voeg tegoed toe om te blijven posten."
   :balance/view-usage "Verbruik bekijken"

   :payment/title "Betaling"
   :payment/method "Betaalmethode"
   :payment/billing-email "Factuur-e-mail"
   :payment/reference "Referentie"
   :payment/update "Betaalmethode wijzigen"
   :payment/card [:fn/str "Kaart ({{:last4}})"]
   :payment/wire-transfer "Bankoverschrijving"

   :billing-email/change "Wijzigen"
   :billing-email/new "Nieuw factuur-e-mailadres"
   :billing-email/save "Opslaan"
   :billing-email/saving "Opslaan..."
   :billing-email/cancel "Annuleren"
   :billing-email/hint "Paddle, onze reseller, stuurt bonnen en facturen naar dit adres."
   :billing-email/shared-hint "Delen meerdere van je organisaties dit factuuraccount, dan geldt de wijziging voor allemaal."
   :billing-email/invalid "Voer een geldig e-mailadres in."
   :billing-email/taken "Dit e-mailadres wordt al gebruikt door een ander factuuraccount. Gebruik een ander adres of stuur ons een chatbericht."

   :customer-conflict/title "Je e-mailadres is al gekoppeld aan een ander account"
   :customer-conflict/text "Je e-mailadres hoort al bij het factuuraccount van een andere Storrito-organisatie, en onze betaalprovider Paddle staat maar één factuuraccount per e-mailadres toe. Stuur ons een chatbericht, dan lossen wij het op."
   :customer-conflict/chat "Supportchat openen"
   :customer-conflict/support-message "Hallo, ik kan de checkout niet openen: mijn e-mailadres hoort al bij een ander factuuraccount."

   :top-up/title "Automatisch opwaarderen"
   :top-up/custom-amount "Eigen bedrag"
   :top-up/opening-checkout "Betaling wordt geopend..."
   :top-up/amount-missing "Vul een bedrag in."
   :top-up/amount-too-small [:fn/str "Het minimum is ${{:minimum}}."]
   :top-up/amount-too-large [:fn/str "Het maximum is ${{:maximum}} per opwaardering. Voor hogere bedragen kun je ons via de chat bereiken."]
   :top-up/per-month [:fn/str "${{:quantity}} elke maand"]
   :top-up/per-year [:fn/str "${{:quantity}} elk jaar"]
   :top-up/stops-on [:fn/str "Stopt op {{:date}}"]
   :top-up/next-on [:fn/str "Volgende opwaardering op {{:date}}"]
   :top-up/status-cancellation-scheduled "opzegging gepland"
   :top-up/status-payment-failed "betaling mislukt"
   :top-up/status-active "actief"
   :top-up/past-due "De laatste opwaardering kon niet worden afgeschreven. "
   :top-up/update-payment-method "Werk je betaalmethode bij"
   :top-up/resume "Automatisch opwaarderen hervatten"
   :top-up/cancel "Automatisch opwaarderen opzeggen"
   :top-up/paddle-unavailable "We konden de gegevens van je automatische opwaardering nu niet bij Paddle ophalen. Probeer het zo nog eens."
   :top-up/try-again "Opnieuw proberen"

   :plan/title-monthly "Maandelijkse opwaardering"
   :plan/title-yearly "Jaarlijkse opwaardering"
   :plan/switch "Overstappen op pay-as-you-go"
   :plan/switching "Overstappen..."
   :plan/switch-confirm [:fn/str "Je terugkerende opwaardering van ${{:quantity}} stopt nu; de overstap zelf is gratis. Je tegoed en je betaalmethode blijven. Daarna betaal je alleen wanneer je tegoed toevoegt, of automatisch met automatisch opwaarderen."]
   :plan/wont-cover [:fn/str "Je saldo dekt je gekoppelde Instagram-accounts waarschijnlijk niet tot de volgende opwaardering op {{:date}}; stories worden niet meer geplaatst bij $0."]
   :plan/wont-cover-advice "Zet hieronder automatisch opwaarderen aan, of voeg nu tegoed toe."

   :on-demand/add-credits "Tegoed toevoegen"
   :on-demand/choose-amount "Kies een bedrag. Je betaalt alleen wat je gebruikt."
   :on-demand/auto-top-up "Automatisch opwaarderen"
   :on-demand/rule [:fn/str "Zakt je saldo onder ${{:threshold}}, dan voegen we automatisch ${{:amount}} toe."]
   :on-demand/auto-top-up-hint "Optioneel. Je stories blijven geplaatst worden als je saldo opraakt — je kunt het altijd uitzetten."
   :on-demand/add [:fn/str "${{:amount}} toevoegen"]
   :on-demand/charged-once "Wordt nu eenmalig afgeschreven via Paddle, onze reseller. Je kaart wordt bewaard voor latere opwaarderingen, niets terugkerends. Tegoed wordt niet terugbetaald. Prijzen excl. btw."
   :on-demand/discount-off [:fn/str "{{:percent}}% korting op"]
   :on-demand/discount-applied "Geldt voor je dagtarief vanaf je eerste opwaardering, niet voor het bedrag dat je opwaardeert. Je welkomsttegoed wordt tegen het normale tarief afgerekend."
   :on-demand/charged-to-card "Wordt afgeschreven van je bewaarde betaalmethode en is binnen enkele seconden beschikbaar."
   :on-demand/confirm-charge [:fn/str "Er wordt nu ${{:amount}} USD excl. belastingen afgeschreven."]
   :on-demand/charging "Bezig met afschrijven..."
   :on-demand/add-now [:fn/str "Nu ${{:amount}} toevoegen"]
   :on-demand/payment-accepted "Betaling geaccepteerd, je saldo wordt binnen enkele seconden bijgewerkt."
   :on-demand/prices-excl-vat "Prijzen excl. btw."
   :on-demand/amount-too-large [:fn/str "Het maximum is ${{:maximum}} per opwaardering."]
   :on-demand/on "Aan"
   :on-demand/off "Uit"
   :on-demand/saving "Opslaan..."
   :on-demand/save "Opslaan"
   :on-demand/custom-auto-top-up-amount "Eigen bedrag voor automatisch opwaarderen"
   :on-demand/one-charge-per-day "Hoogstens één automatische afschrijving per dag, van je bewaarde betaalmethode, plus de geldende belastingen."
   :on-demand/remove-payment-method "Betaalmethode verwijderen"

   :transactions/title "Recente transacties"
   :transactions/full-statement "Volledig overzicht"
   :transactions/invoices "Facturen"
   :transactions/date "Datum"
   :transactions/description "Omschrijving"
   :transactions/amount "Bedrag"
   :transactions/error "De transacties konden niet worden geladen."
   :transactions/empty "Deze maand nog geen aankopen."
   :transactions/welcome-credits "Welkomsttegoed"
   :transactions/recurring-top-up "Terugkerende opwaardering"
   :transactions/added-credits "Tegoed toegevoegd"
   :transactions/refund "Terugbetaling tegoed"

   :credit-notes/view "Creditnota's"
   :credit-notes/title "Creditnota's"
   :credit-notes/intro "Creditnota's voor je terugbetalingen en tegoeden. Paddle, onze reseller, geeft ze uit."
   :credit-notes/refund "Terugbetaling"
   :credit-notes/credit "Tegoed"
   :credit-notes/download "PDF downloaden"
   :credit-notes/empty "Nog geen creditnota's."
   :credit-notes/error "De creditnota's konden niet worden geladen."

   :offer/applied-automatically "Wordt automatisch toegepast wanneer je tegoed toevoegt. Tot die tijd wordt je welkomsttegoed tegen het normale tarief afgerekend."

   :rates/view "Bekijk onze tarieven"
   :rates/title "Onze tarieven in één oogopslag"
   :rates/intro "Hier zie je wat we per dienst rekenen. "
   :rates/intro-bold "Alle prijzen in Amerikaanse dollars exclusief belastingen (excl. btw)."
   :rates/per-day "per dag"
   :rates/per-post "per post"
   :rates/per-image "per afbeelding"
   :rates/per-days [:fn/str "per {{:days}} dagen"]
   :rates/excl-vat "Alle prijzen excl. btw"
   :rates/off [:fn/str "{{:percent}}% KORTING"]

   :service.storage-flat-fee/name "Vast opslagtarief"
   :service.storage-flat-fee/description "voor al je afbeeldingen, video's enz."
   :service.instagram-connection/name "Instagram-accountkoppeling"
   :service.instagram-connection/description "Onbeperkt Stories en Reels voor één Instagram-gebruikersnaam."
   :service.tiktok-post/name "TikTok-post"
   :service.tiktok-post/description "Publiceer een video of afbeelding op TikTok."
   :service.youtube-short/name "YouTube Short"
   :service.youtube-short/description "Publiceer een gerenderde video als YouTube Short."
   :service.social-post/name "Social-post"
   :service.social-post/description "Publiceer een gerenderde video of afbeelding op Facebook, Threads en andere gekoppelde platforms (X wordt apart gerekend)."
   :service.x-post/name "X-post"
   :service.x-post/description "Publiceer een gerenderde video op X. X rekent voor elke post via zijn API, daarom kosten X-posts meer dan andere social posts."
   :service.x-post-link/name "X-post met link"
   :service.x-post-link/description "Een X-post waarvan de tekst een link bevat. X rekent veel meer voor posts met links."
   :service.ai-image/name "AI-afbeelding"
   :service.ai-image/description "Een afbeelding maken met AI (Dall-e / Blackforest)."})
